import memoize                                                                    from 'lodash-es/memoize';
import { ChartPosition, ChartValues, DataZoomAxis, DataZoomConfig, DataZoomType } from '@/components/chart/helpers/chart-variables';
import { getCSSVariable, rgbStringToHex }                                         from '@/styles/variables.helpers';
import roundNumberFilter                                                          from '@/helpers/helpers';
import { getDataZoomInsideConfig, getDataZoomSliderConfig }                       from '@/components/chart/hooks/use-chart-options';
import { ChartYAxis, GeneralChartConfiguration }                                  from '@/components/chart/chart.types';
import { XAxisSeries }                                                            from '@/views/x-axis-report/report-edit/types/types';
import { useXAxisTooltipContent }                                                 from '@/views/x-axis-report/report-edit/hooks/chart/use-x-axis-tooltip-content.hook';

import Format = echarts.EChartOption.Tooltip.Format;

export const defaultYAxis: ChartYAxis[] = [
  {
    type: ChartValues.VALUE,
    position: ChartPosition.LEFT,
    axisLabel: {
      color: rgbStringToHex(getCSSVariable('--black')),
      formatter: memoize((value: number) => roundNumberFilter(value)),
    },
    axisLine: {
      lineStyle: {
        color: rgbStringToHex(getCSSVariable('--grey-200')),
        width: 2,
      },
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: rgbStringToHex(getCSSVariable('--grey-100')),
      },
    },
    splitNumber: 4,
  },
  {
    type: ChartValues.VALUE,
    silent: true,
    axisLabel: {
      show: false,
    },
    axisTick: {
      show: false,
    },
  },
];

export const xAxisReportConfig: GeneralChartConfiguration<XAxisSeries> = {
  grid: {
    left: 0,
    right: 50,
    top: 60,
    bottom: 20,
  },
  legend: {
    top: 15,
    right: '25%',
    left: 0,
    type: ChartValues.SCROLL,
    itemGap: 30,
    itemWidth: 10,
    pageIconColor: rgbStringToHex(getCSSVariable('--primary-400')),
    data: [],
    textStyle: {
      color: rgbStringToHex(getCSSVariable('--black')),
    },
  },
  tooltip: {
    trigger: ChartValues.AXIS,
    triggerOn: ChartValues.CLICK,
    backgroundColor: rgbStringToHex(getCSSVariable('–-white')),
    padding: 10,
    textStyle: {
      color: rgbStringToHex(getCSSVariable('–-black')),
    },
    axisPointer: {
      type: 'none',
    },
    extraCssText: 'background-color: transparent;',
    enterable: true,
    formatter: memoize((params: Format | Format[]): string => useXAxisTooltipContent(params)),
  },
  dataZoom: [
    {
      ...getDataZoomSliderConfig(
        DataZoomType.SLIDER,
        {
          start: 0,
          end: 100,
          axis: DataZoomAxis.Y_AXIS,
        },
      ),
      filterMode: 'none',
      width: DataZoomConfig.THICKNESS,
      top: '15%',
      right: 10,
      bottom: '15%',
    },
    {
      ...getDataZoomInsideConfig(
        DataZoomType.INSIDE,
        {
          start: 0,
          end: 100,
          axis: DataZoomAxis.Y_AXIS,
        },
      ),
    },
  ],
  xAxis: [{
    type: ChartValues.CATEGORY,
  }],
  yAxis: defaultYAxis,
  series: [],
};
